import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import scalable from "../../../assets/icons/scalable.png";
import ideas from "../../../assets/icons/ideas.png";
import inclusion from "../../../assets/icons/inclusion.png";
import africa from "../../../assets/icons/africa.png";

const cardStyle = {
  bgcolor: "#fff",
  color: "#000",
};

const objectList = [
  {
    icon: scalable,
    title: "Big Bets on Scalable Solutions",
    subtitle:
      "Investing in proven, high-impact models like low-cost flood sensors to expand transformative solutions across Africa, saving lives and reducing disaster losses.",
  },
  {
    icon: ideas,
    title: "Early Bets on Emerging Ideas",
    subtitle:
      "Backing innovative, early-stage concepts such as AI-powered urban planning tools, enabling local innovators to pilot and scale impactful solutions for underserved areas.",
  },
  {
    icon: inclusion,
    title: "Prioritizing Inclusion and Equity",
    subtitle:
      "Ensuring African-led projects benefit women, youth, people with disabilities, and marginalized groups by embedding equity and accessibility in funding criteria.",
  },
  {
    icon: africa,
    title: " Promoting African Resilience",
    subtitle:
      "Building sustainable local capacity through investments in infrastructure, governance, and community-led planning to empower African communities to adapt and thrive.",
  },
];

const Principles = () => {
  return (
    <Box margin={{ xs: "35% 0%", sm: "10% 0% 10% 0%" }}>
      <Typography
        variant="h3"
        fontWeight={700}
        textAlign={"center"}
        paddingBottom={{ xs: "4%", sm: "4%" }}
        color={"#39484E"}
      >
        Our Guiding Principles
      </Typography>
      <Grid container spacing={1}>
        {objectList.map((list, index) => {
          const { title, icon, subtitle } = list;
          return (
            <>
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                margin={{ xs: "5% 0%", sm: "0%" }}
              >
                <Box
                  key={index}
                  component={Card}
                  height={"100%"}
                  padding={{ xs: "4% 4%", sm: "8% 8% 4% 8%" }}
                  margin={{ xs: "2% 0%", sm: "4% 0%" }}
                  borderRadius={"20px"}
                  display={"flex"}
                  flexDirection={"column"}
                  width={{ xs: "100%", sm: "100%" }}
                  sx={{ ...cardStyle }}
                >
                  <Box marginLeft={"2%"}>
                    {" "}
                    <Box
                      component="img"
                      height={{ xs: "64px", sm: "64px" }}
                      sx={{
                        objectFit: "cover",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={icon}
                      alt={"icons"}
                    />
                  </Box>
                  <Typography
                    variant={"h5"}
                    fontWeight={700}
                    paddingTop={"6%"}
                    color={"#39484E"}
                  >
                    {title}
                  </Typography>
                  <Typography
                    variant={"body1"}
                    paddingTop={"6%"}
                    color={"#000"}
                  >
                    {subtitle}
                  </Typography>
                </Box>
              </Grid>
            </>
          );
        })}
      </Grid>
    </Box>
  );
};

export default Principles;
